import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { Pagination } from "../../../ui/organisms/pagination"
import { Calendar } from "../../../ui/molecules/calendar"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { format } from "date-fns"
import { ReportProvvedimentiList } from "./list"
import { SelectCustom } from "../../../ui/molecules/select"
import { regioniList, sot, yearOptions } from "../../../utils"

export function ReportProvvedimenti() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const oldCodexMeasure = useAppSelector(state => state.oldCodexMeasure)

    // if (newMeasureState.getAllAppliedMeasureResponse === 'loading') {
    //     return (
    //         <LogoSpinnerComponent fullScreen />
    //     )
    // }

    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Report Provvedimenti']}
            noPaddingLat
            headerLabel="Report Provvedimenti"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">
                            <div style={{ flex: '0.4' }}>
                                <SelectCustom
                                    label="Anno"
                                    placeholder={'Anno'}
                                    options={yearOptions}
                                    // onChange={(value) => dispatch(setGetAllM24EmessiYear(value))}
                                />
                            </div>

                            <div style={{ flex: '0.4' }}>
                                <Calendar
                                    label="Dal"
                                    //onClear={(date) => dispatch(setGetAllEPFilterFrom(date))}
                                    // selected={m24EmessiState.GetAllM24EmessiFilters.from}
                                    // onChange={(date) => dispatch(setGetAllM24EmessiStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.4' }}>
                                <Calendar
                                    label="Al"
                                    // onClear={(date) => dispatch(setGetAllEPFilterTo(date))}
                                    // selected={m24EmessiState.GetAllM24EmessiFilters.to}
                                    // onChange={(date) => dispatch(setGetAllFaseAvvioEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>

                            <div style={{ flex: '0.4' }}>
                                <SelectCustom
                                    label="Sede"
                                    placeholder='Sede'
                                    options={sot}
                                    // onChange={(value) => dispatch(setGetAllM24EmessiSot(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                // dispatch(GetAllM24Emessi(m24EmessiState.GetAllM24EmessiFilters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">
                            
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={m24OpenState.GetAllFaseAvvioResponse ? m24OpenState.GetAllFaseAvvioResponse.total : 0}
                                pages={m24OpenState.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={m24OpenState.GetAllM24EmessiFilters.page ? m24OpenState.GetAllM24EmessiFilters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllM24EmessiFiltersPage(page))
                                        dispatch(GetAllFaseAvvio(m24OpenState.GetAllM24EmessiFilters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                <ReportProvvedimentiList />
            </div>
        </Layout>
    )
}